export enum ProcessingState {
  NotStarted,
  Running,
  Successful,
  Error,
}
